module.exports = __webpack_public_path__ + "static/dsb1-logo-8bf713444e2edd3d1d2fc39941e8f68a.png";